module.exports = __webpack_public_path__ + "media/warbling-vireo-1.4c198e64.mp3";